<template>
  <v-dialog v-model="dialog" width="800" scrollable>
    <v-card flat>
      <v-card-title class="pa-0">
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-tabs v-if="useTab" v-model="tab" @change="fetchData">
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab v-for="item in items" :key="item.url">
            {{ item.text }}
          </v-tab>
        </v-tabs>

        <v-alert type="info" text v-if="selected.length">
          <div>
            <span class="red--text">{{ selected.length }} {{ title.split(' ')[1] || '-' }}</span> Terpilih
          </div>
        </v-alert>
        <base-table-header @search="onSearch" @reload="onReload"> </base-table-header>
        <base-list-table no-data :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
          <template v-slot:nodata>
            <div class="text-center py-5">
              Belum ada data yang ditemukan. Silakan lakukan pencarian data untuk penambahan Peserta Diklat
            </div>
          </template>
          <template slot-scope="{ item }">
            <td class="px-0">
              <v-list-item dense class="px-0" @click="onSelect(item)">
                <v-list-item-action class="mr-0">
                  <v-list-item-action-text>
                    <v-col v-if="multiselect" cols="12" md="1" sm="1" class="px-5">
                      <v-checkbox
                        v-model="
                          select[
                            $getDeepObj(item, Number(tab) === 3 ? 'paud_peserta_nonptk_id' : 'id') ||
                              $getDeepObj(item, 'ptk_id')
                          ]
                        "
                        :disabled="
                          Number(tab) === 0
                            ? !!$getDeepObj(item, 'peserta')
                            : Number(tab) === 2
                            ? !item.is_baru
                            : Number(tab) === 3 &&
                              (!$getDeepObj(item, 'sertifikat_url') || !$getDeepObj(item, 'sk_instansi_url'))
                            ? true
                            : false
                        "
                      ></v-checkbox>
                    </v-col>
                  </v-list-item-action-text>
                </v-list-item-action>
                <v-list-item-content>
                  <v-row>
                    <v-col v-for="(field, f) in fields" :key="f" v-bind="field.grid">
                      <v-list-item class="px-0">
                        <v-list-item-avatar v-if="field.icon" color="secondary">
                          <v-icon dark>{{ field.icon }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <div v-if="field.items">
                            <div v-for="(fieldItem, id) in field.items" :key="id">
                              <div
                                v-if="
                                  fieldItem.title && ((field.key && field.key[tab]) || $getDeepObj(item, fieldItem.key))
                                "
                                class="caption"
                                v-html="fieldItem.title"
                              />
                              <div v-bind="fieldItem.custom">
                                {{
                                  field.key && field.key[tab]
                                    ? $getDeepObj(item, fieldItem.key[tab])
                                    : $getDeepObj(item, fieldItem.key)
                                }}
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div class="caption" v-html="field.title" />
                            <div v-bind="field.custom">
                              {{
                                field.key && field.key[tab]
                                  ? $getDeepObj(item, field.key[tab])
                                  : $getDeepObj(item, field.key)
                              }}
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col v-if="Number(tab) === 3" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span
                            :class="[
                              'caption',
                              !$getDeepObj(item, 'sertifikat_url') || !$getDeepObj(item, 'sk_instansi_url')
                                ? 'purple--text'
                                : 'success--text',
                            ]"
                          >
                            {{
                              !$getDeepObj(item, 'sertifikat_url') || !$getDeepObj(item, 'sk_instansi_url')
                                ? 'Belum Unggah Dokumen'
                                : 'Sudah Unggah Dokumen'
                            }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
        <v-divider />
      </v-card-text>
      <div v-if="total >= 10 || Number(params.page) > 1" class="text-center pt-2 mt-2">
        <v-btn small depressed rounded color="secondary" :disabled="!params.page || params.page === 1" @click="onBack">
          <v-icon small color="light">mdi-chevron-left</v-icon> Sebelumnya
        </v-btn>
        <span class="mx-1"></span>
        <v-btn small depressed rounded color="secondary" :disabled="!hasMore" @click="onNext">
          Berikutnnya <v-icon small color="light">mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <div class="text-right pa-2">
        <v-btn text @click="dialog = false">Batal</v-btn>
        <v-btn color="primary" :disabled="!selected.length" @click="onSaveSelection">Simpan</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
export default {
  mixins: [list],
  props: {
    api: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: [String, Number],
      default: '',
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    useTab: {
      type: Boolean,
      default: true,
    },
    custUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      fields: [],
      select: {},
      tab: null,
      total: 0,
      items: [
        {
          url: 'peserta/kandidat',
          text: 'SIMPKB PAUD',
        },
        {
          url: 'peserta/kandidat-sd',
          text: 'SIMPKB SD',
        },
        {
          url: 'peserta/kandidat-simpatika',
          text: 'SIMPKB RA',
        },
        {
          url: 'peserta/kandidat-nonptk',
          text: 'Kandidat Non Dapodik',
        },
      ],
      hasMore: false,
    };
  },

  computed: {
    selected() {
      let temp = [];
      Object.keys(this.select).forEach((item) => {
        if (this.select[item]) temp.push(item);
      });
      return temp;
    },
  },

  methods: {
    fetchData() {
      if (!this.params.keyword && this.useTab) return;
      this.$set(this.params, 'tipe', this.items[this.tab]['url']);

      if (this.custUrl) {
        this.$set(this.params, 'tipe', this.custUrl);
      }

      this.$delete(this.params.params, 'k_petugas_paud');
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      this.$store.dispatch(this.api, params).then((resp) => {
        this.data = (resp && resp.data) || [];
        this.total = (resp && resp.data && resp.data.length) || 0;
        this.hasMore = (resp && resp.meta && resp.meta.has_more) || false;
        this.params.page = (resp && resp.meta && resp.meta.current_page) || 1;
      });
    },

    open(fields, params = {}) {
      this.dialog = true;
      this.fields = fields || [];
      this.params = params || {};
      this.data = [];
      this.select = {};
      this.tab = 0;
      this.fetchData();

      if (params.jenis === 'daring') {
        const find = this.items.findIndex((s) => s.url === 'peserta/kandidat-nonptk');
        if (find > -1) this.items.splice(find, 1);
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect(item) {
      if (this.multiselect) return;
      this.resolve(item);
      this.dialog = false;
    },

    onSaveSelection() {
      this.resolve(this.selected);
      this.dialog = false;
    },

    onNext() {
      const page = this.params.page || 1;
      this.$set(this.params, 'page', page + 1);
      this.fetchData();
    },

    onBack() {
      const page = this.params.page || 1;
      this.$set(this.params, 'page', page - 1);
      this.fetchData();
    },

    onSearch(keyword) {
      if (keyword.length < 3 && this.useTab) {
        this.$error('Jumlah karakter minimal 3');
        return;
      }
      Object.assign(this.params, { keyword: keyword, page: 1 });
      this.fetchData();
    },
  },

  watch: {
    tab: function () {
      this.select = {};
    },
  },
};
</script>
